var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTuDelftWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.77 39.610601",
    xmlSpace: "preserve",
    width: 141.77,
    height: 39.610603,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs762"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style653"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g757",
    transform: "translate(-75.73,-184.7194)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.169998,
    y: 175.17,
    className: "st0",
    width: 162.64,
    height: 76.540001,
    id: "rect655"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g749"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 104.55,219.69 c 2.49,0 3.85,-1.65 3.85,-3.98 v -11.84 h 5.3 v 12.11 c -0.05,5.33 -4.32,7.42 -9.15,7.42 -4.83,0 -9.09,-2.09 -9.15,-7.42 v -12.11 h 5.3 v 11.84 c 0.01,2.32 1.36,3.98 3.85,3.98 z",
    id: "path657"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 139.67,215.08 c 0.02,-2.08 1.27,-3.95 3.37,-3.95 2.44,0 3.39,1.67 3.39,3.95 z m 9.42,1.75 v -1.25 c 0,-3.68 -2.09,-6.28 -5.86,-6.28 -4.21,0 -6.18,3.26 -6.18,7.16 0,3.92 1.7,6.95 5.97,6.95 3.18,0 5.51,-1.51 5.91,-4.53 h -2.65 c -0.29,1.93 -1.27,2.7 -3.23,2.7 -2.57,0 -3.43,-2.29 -3.43,-4.74 h 9.47 z",
    id: "path659"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.14,
    y: 203.87,
    className: "st1",
    width: 2.52,
    height: 19.129999,
    id: "rect661"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "92.91,203.87 75.73,203.87 75.73,207.58 81.67,207.58 81.67,223 86.97,223 86.97,207.58 92.91,207.58 ",
    id: "polygon663"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 94.41,194.55 c -1.29,0.41 -2.63,0.08 -2.62,-1.65 0,-2.64 6.19,-4.85 7.05,-7.15 0.21,-0.57 0.23,-1.05 -0.05,-1.03 -0.2,0.01 -0.04,0.3 -0.48,0.73 -2.56,2.57 -6.86,2.56 -10.16,4.04 -2.16,0.97 -8.5,3.95 -7.04,10.6 0.07,0.32 0.26,1.37 0.45,1.37 0.22,0 0.22,-0.63 0.22,-1.39 -0.05,-3.96 4.64,-5.06 6.17,-7.65 0.18,-0.31 0.5,-0.74 0.57,-0.54 0.04,0.1 0.01,0.24 -0.05,0.52 -0.48,2.13 -2.7,3.49 -2.07,5.01 0.82,1.97 3.17,0.5 3.9,-0.77 0.19,-0.35 0.3,-0.57 0.43,-0.53 0.1,0.03 0.09,0.43 0.03,0.79 -0.39,2.29 -0.91,3.57 -2.59,4.88 -0.54,0.42 -1.38,0.5 -1.27,0.82 0.03,0.08 0.39,0.07 0.68,0.04 4.46,-0.29 8.19,-5.54 9.18,-8.98 0.1,-0.24 0.13,-0.47 0.03,-0.55 -0.13,-0.1 -0.33,0.13 -0.53,0.31 -0.51,0.46 -1.21,0.93 -1.85,1.13 z",
    id: "path665"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g671"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 182.31,203.87 c 1.63,0 2.56,0.84 2.56,2.48 0,1.64 -0.93,2.48 -2.56,2.48 h -1.34 v -4.96 z m 0.11,4.55 c 1.39,0 1.96,-0.82 1.96,-2.07 0,-1.46 -0.86,-2.11 -2.27,-2.07 h -0.7 v 4.14 z",
    id: "path667"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 185.9,207.2 c 0.01,0.73 0.35,1.35 1.2,1.35 0.49,0 0.89,-0.35 1,-0.83 h 0.43 c -0.21,0.83 -0.73,1.2 -1.56,1.2 -1.03,0 -1.51,-0.89 -1.51,-1.83 0,-0.93 0.52,-1.83 1.54,-1.83 1.15,0 1.57,0.85 1.57,1.92 h -2.67 z m 2.22,-0.38 c -0.05,-0.67 -0.41,-1.17 -1.12,-1.17 -0.67,0 -1.03,0.56 -1.09,1.17 z",
    id: "path669"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g677"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 189.72,208.83 h -0.41 v -4.96 h 0.41 z",
    id: "path673"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 191.03,208.83 v -3.07 h -0.69 v -0.38 h 0.69 v -0.74 c 0,-0.59 0.24,-0.86 0.83,-0.86 0.13,0 0.27,0.05 0.39,0.08 v 0.33 c -0.08,-0.01 -0.17,-0.03 -0.25,-0.03 -0.56,0 -0.58,0.28 -0.56,0.78 v 0.44 h 0.78 v 0.38 h -0.78 v 3.07 z",
    id: "path675"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g681"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 193.2,205.76 h -0.69 v -0.38 h 0.69 v -0.74 l 0.41,-0.18 v 0.91 h 0.78 v 0.38 h -0.78 v 2.31 c -0.01,0.32 0.16,0.49 0.47,0.49 0.12,0 0.25,-0.01 0.36,-0.04 v 0.36 c -0.13,0.03 -0.28,0.06 -0.42,0.06 -0.87,0 -0.82,-0.56 -0.82,-1.02 z",
    id: "path679"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g687"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 181.42,210.95 v 3.21 c 0.03,0.9 0.55,1.44 1.37,1.44 0.82,0 1.33,-0.54 1.37,-1.44 v -3.21 h 0.45 v 3.22 c -0.01,1.07 -0.61,1.85 -1.81,1.85 -1.2,0 -1.8,-0.78 -1.81,-1.85 v -3.22 z",
    id: "path683"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 185.89,215.91 h -0.41 v -2.67 c 0,-0.27 -0.02,-0.54 -0.03,-0.78 h 0.43 l 0.02,0.51 0.01,0.01 c 0.24,-0.43 0.63,-0.62 1.08,-0.62 1.13,0 1.22,1 1.22,1.39 v 2.16 h -0.41 v -2.23 c 0,-0.6 -0.34,-0.95 -0.91,-0.95 -0.68,0 -0.99,0.57 -0.99,1.19 v 1.99 z",
    id: "path685"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g693"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 189.57,211.47 h -0.48 v -0.52 h 0.48 z m -0.03,1 v 3.45 h -0.41 v -3.45 z",
    id: "path689"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 190.64,212.47 1.19,2.88 1.15,-2.88 h 0.45 l -1.37,3.45 h -0.47 l -1.41,-3.45 z",
    id: "path691"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g703"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 194.15,214.29 c 0.01,0.74 0.35,1.35 1.2,1.35 0.49,0 0.89,-0.35 1,-0.82 h 0.43 c -0.21,0.82 -0.73,1.2 -1.56,1.2 -1.03,0 -1.51,-0.89 -1.51,-1.83 0,-0.93 0.52,-1.83 1.54,-1.83 1.16,0 1.57,0.85 1.57,1.92 h -2.67 z m 2.22,-0.38 c -0.05,-0.67 -0.41,-1.17 -1.12,-1.17 -0.67,0 -1.03,0.56 -1.09,1.17 z",
    id: "path695"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 198,215.91 h -0.41 v -2.67 c 0.01,-0.27 -0.02,-0.54 -0.04,-0.78 h 0.43 l 0.02,0.51 h 0.01 c 0.12,-0.35 0.43,-0.6 0.78,-0.61 0.14,-0.01 0.27,0 0.41,0.01 v 0.4 c -0.08,-0.01 -0.17,-0.03 -0.25,-0.03 -0.61,0 -0.93,0.44 -0.95,1.1 z",
    id: "path697"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 200.89,212.36 c 0.65,0 1.2,0.23 1.26,0.95 h -0.45 c -0.04,-0.43 -0.43,-0.58 -0.85,-0.58 -0.39,0 -0.78,0.15 -0.78,0.56 0,0.51 0.67,0.46 1.6,0.79 0.36,0.12 0.58,0.43 0.58,0.8 0,0.78 -0.72,1.13 -1.45,1.13 -0.6,0 -1.29,-0.28 -1.3,-1.04 h 0.45 c 0.03,0.52 0.49,0.67 0.96,0.67 0.44,0 0.9,-0.21 0.9,-0.69 0,-0.49 -0.54,-0.58 -1.09,-0.7 -0.54,-0.13 -1.09,-0.29 -1.09,-0.93 -0.01,-0.71 0.65,-0.96 1.26,-0.96 z",
    id: "path699"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 203.5,211.47 h -0.48 v -0.52 h 0.48 z m -0.04,1 v 3.45 h -0.41 v -3.45 z",
    id: "path701"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g709"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 204.87,212.84 h -0.69 v -0.38 h 0.69 v -0.74 l 0.41,-0.18 v 0.91 h 0.78 v 0.38 h -0.78 v 2.31 c -0.01,0.32 0.16,0.49 0.47,0.49 0.12,0 0.25,-0.01 0.36,-0.04 v 0.36 c -0.13,0.03 -0.28,0.06 -0.42,0.06 -0.87,0 -0.82,-0.56 -0.82,-1.02 z",
    id: "path705"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 207.07,212.47 1.16,2.89 1.15,-2.89 h 0.45 l -1.9,4.77 h -0.45 l 0.52,-1.32 -1.43,-3.45 z",
    id: "path707"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g713"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 215.32,214.19 c 0,0.91 -0.51,1.83 -1.61,1.83 -1.1,0 -1.61,-0.92 -1.61,-1.83 0,-0.91 0.51,-1.83 1.61,-1.83 1.1,0 1.61,0.92 1.61,1.83 z m -1.61,-1.45 c -0.83,0 -1.16,0.81 -1.16,1.45 0,0.64 0.33,1.45 1.16,1.45 0.83,0 1.16,-0.81 1.16,-1.45 0,-0.64 -0.33,-1.45 -1.16,-1.45 z",
    id: "path711"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g717"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 216.28,215.91 v -3.07 h -0.69 v -0.38 h 0.69 v -0.74 c 0,-0.59 0.24,-0.86 0.83,-0.86 0.13,0 0.27,0.05 0.39,0.08 v 0.33 c -0.08,-0.01 -0.17,-0.03 -0.25,-0.03 -0.56,0 -0.58,0.28 -0.56,0.78 v 0.44 h 0.78 v 0.38 h -0.78 v 3.07 z",
    id: "path715"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g723"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 182.57,218.45 h -1.6 v -0.41 h 3.63 v 0.41 h -1.57 V 223 h -0.45 v -4.55 z",
    id: "path719"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 184.56,221.37 c 0.01,0.74 0.35,1.35 1.2,1.35 0.49,0 0.89,-0.35 1,-0.82 h 0.43 c -0.21,0.82 -0.73,1.2 -1.56,1.2 -1.03,0 -1.51,-0.89 -1.51,-1.83 0,-0.93 0.52,-1.83 1.54,-1.83 1.15,0 1.57,0.85 1.57,1.92 h -2.67 z m 2.22,-0.37 c -0.05,-0.67 -0.41,-1.17 -1.12,-1.17 -0.67,0 -1.03,0.56 -1.09,1.17 z",
    id: "path721"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g729"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 190.24,220.61 c -0.03,-0.53 -0.37,-0.78 -0.94,-0.78 -0.63,0 -1.02,0.66 -1.02,1.44 0,0.79 0.39,1.46 1.02,1.46 0.54,0 0.91,-0.33 0.94,-0.8 h 0.45 c -0.11,0.79 -0.56,1.18 -1.35,1.18 -1.03,0 -1.51,-0.89 -1.51,-1.83 0,-0.93 0.52,-1.83 1.54,-1.83 0.71,0 1.29,0.43 1.32,1.16 z",
    id: "path725"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 191.78,220.08 h 0.01 c 0.24,-0.43 0.63,-0.63 1.08,-0.63 1.13,0 1.22,1 1.22,1.39 V 223 h -0.41 v -2.23 c 0,-0.6 -0.34,-0.95 -0.91,-0.95 -0.68,0 -0.99,0.57 -0.99,1.19 V 223 h -0.41 v -4.96 h 0.41 z",
    id: "path727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g735"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 195.32,223 h -0.41 v -2.67 c 0,-0.27 -0.02,-0.54 -0.03,-0.78 h 0.43 l 0.02,0.51 0.01,0.01 c 0.24,-0.43 0.63,-0.63 1.08,-0.63 1.13,0 1.22,1 1.22,1.39 V 223 h -0.41 v -2.23 c 0,-0.6 -0.34,-0.95 -0.91,-0.95 -0.68,0 -0.99,0.57 -0.99,1.19 V 223 Z",
    id: "path731"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 201.6,221.28 c 0,0.91 -0.51,1.83 -1.61,1.83 -1.1,0 -1.61,-0.92 -1.61,-1.83 0,-0.91 0.51,-1.83 1.61,-1.83 1.1,0 1.61,0.92 1.61,1.83 z m -1.61,-1.45 c -0.83,0 -1.16,0.81 -1.16,1.45 0,0.64 0.33,1.45 1.16,1.45 0.83,0 1.16,-0.81 1.16,-1.45 0.01,-0.64 -0.32,-1.45 -1.16,-1.45 z",
    id: "path733"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g741"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 202.72,223 h -0.41 v -4.96 h 0.41 z",
    id: "path737"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 206.66,221.28 c 0,0.91 -0.51,1.83 -1.61,1.83 -1.1,0 -1.61,-0.92 -1.61,-1.83 0,-0.91 0.51,-1.83 1.61,-1.83 1.1,0 1.61,0.92 1.61,1.83 z m -1.61,-1.45 c -0.83,0 -1.16,0.81 -1.16,1.45 0,0.64 0.33,1.45 1.16,1.45 0.83,0 1.16,-0.81 1.16,-1.45 0,-0.64 -0.33,-1.45 -1.16,-1.45 z",
    id: "path739"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g747"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 209.9,219.55 h 0.43 c -0.01,0.23 -0.03,0.51 -0.03,0.78 v 2.07 c 0,0.69 0.03,1.41 -0.73,1.77 -0.27,0.13 -0.46,0.16 -0.78,0.16 -0.62,0 -1.37,-0.21 -1.37,-0.93 h 0.45 c 0.05,0.41 0.54,0.55 0.98,0.55 0.54,0 1.03,-0.38 1.04,-0.95 v -0.65 h -0.01 c -0.2,0.41 -0.67,0.65 -1.12,0.65 -1.04,0 -1.48,-0.79 -1.48,-1.74 0,-0.93 0.42,-1.8 1.47,-1.8 0.5,0 0.86,0.24 1.13,0.64 l 0.01,-0.03 z m -1.13,0.28 c -0.75,0 -1.07,0.76 -1.07,1.39 0,0.63 0.32,1.39 1.08,1.39 0.79,0 1.09,-0.74 1.09,-1.41 0.01,-0.66 -0.36,-1.37 -1.1,-1.37 z",
    id: "path743"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 211.34,219.55 1.16,2.89 1.15,-2.89 h 0.45 l -1.9,4.77 h -0.45 l 0.52,-1.32 -1.43,-3.45 z",
    id: "path745"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 162.56,223 v -11.55 h 3.07 v -1.75 h -3.07 v -2.15 c 0,-1.54 0.74,-1.8 2.17,-1.8 0.42,0 0.85,0.05 1.27,0.08 v -2.09 c -0.59,-0.13 -1.19,-0.27 -1.8,-0.27 -2.38,0 -4.16,1.2 -4.16,3.74 v 2.49 h -2.6 v 1.75 h 2.6 V 223 Z",
    id: "path751"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 167.07,209.7 v 1.75 h 2.28 v 8.48 c 0,1.77 0.03,3.47 3.77,3.47 0.58,0 1.13,-0.05 1.72,-0.16 v -1.93 c -0.41,0.1 -0.93,0.16 -1.33,0.16 -0.9,0 -1.64,-0.45 -1.64,-1.4 v -8.61 h 3.07 v -1.75 h -3.07 v -3.63 l -2.52,0.79 v 2.84 z",
    id: "path753"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 119,223 h 6.57 c 8.18,0 9.04,-6.93 9.04,-9.57 0,-2.64 -0.86,-9.57 -9.04,-9.57 H 119 Z m 2.65,-16.85 h 3.92 c 4.42,0 6.26,3.34 6.26,7.29 0,3.95 -1.84,7.29 -6.26,7.29 h -3.92 z",
    id: "path755"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuDelftWhite);
export default __webpack_public_path__ + "static/media/TUDelftWhite.9e959077fe551158483d49984a6b372c.svg";
export { ForwardRef as ReactComponent };